import { useQuery } from '@tanstack/react-query';
import { LeadTimeAlert, LeadTimeAlertCounts } from '@models/warehouse.model';
import { warehouseService } from '@services/warehouse';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';

export const LEAD_TIME_ALERTS_QUERY_KEY = ['leadTimeAlerts'];
export const LEAD_TIME_ALERT_COUNTS_QUERY_KEY = ['leadTimeAlertCounts'];

export const useLeadTimeAlerts = () => {
  const isLoggedIn = useAppSelector((state: RootState) => state.user.isLoggedIn);
  const { organizationId } = useAppSelector(
    (state: RootState) => state.organization,
  );

  return useQuery<LeadTimeAlert[], Error>({
    queryKey: LEAD_TIME_ALERTS_QUERY_KEY,
    queryFn: async () => {
      return await warehouseService.getLeadTimeAlerts();
    },
    // Don't run with a stale/expired session: an unauthenticated request would
    // trigger the global auto-logout in graphqlClient. Requires an active org.
    enabled: isLoggedIn && !!organizationId,
    staleTime: 2 * 60 * 1000,
  });
};

export const useLeadTimeAlertCounts = (options: { enabled?: boolean } = {}) => {
  const isLoggedIn = useAppSelector((state: RootState) => state.user.isLoggedIn);
  const { organizationId } = useAppSelector(
    (state: RootState) => state.organization,
  );

  return useQuery<LeadTimeAlertCounts, Error>({
    queryKey: LEAD_TIME_ALERT_COUNTS_QUERY_KEY,
    queryFn: async () => {
      return await warehouseService.getLeadTimeAlertCounts();
    },
    // Don't run with a stale/expired session: an unauthenticated request would
    // trigger the global auto-logout in graphqlClient. Requires an active org.
    enabled: isLoggedIn && !!organizationId && (options.enabled ?? true),
    staleTime: 2 * 60 * 1000,
  });
};
